import { render, staticRenderFns } from "./ProductPositionFields.vue?vue&type=template&id=3f480490&"
import script from "./ProductPositionFields.vue?vue&type=script&lang=js&"
export * from "./ProductPositionFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports